import React, { PropTypes } from 'react';
import FanBoxMessageForm from '../FanBoxMessageForm';
import LoadingSpinner from '../../LoadingSpinner';

class FanBoxMessageEdit extends React.Component {
  static propTypes = {
    loading: PropTypes.bool.isRequired,
    fetch: PropTypes.func
  };

  constructor(props) {
    super(props);
  }

  componentDidMount() {
    let { id } = this.props.params;
    this.props.fetch(id);
  }

  state = {
    loading: true
  };

  componentWillReceiveProps(nextProps) {
    let { loading } = nextProps;
    this.setState({loading: this.state.loading && loading});
  }

  render() {
    let { loading, ...rest } = this.state;

    return (
      <LoadingSpinner show={false}>
        {!loading
          ? (<FanBoxMessageForm label="Edit Message" {...rest}/>)
          : null
        }
      </LoadingSpinner>
    );
  }
}

export default FanBoxMessageEdit;




// WEBPACK FOOTER //
// ./src/components/FanBox/FanBoxMessageEdit/FanBoxMessageEdit.jsx